import React from 'react';
import { Building2, CheckCircle2, Clapperboard } from 'lucide-react';
import './marketingDemos.css';

const WORKSPACES = [
  {
    id: 'northstar',
    name: 'Northstar Media',
    summary: '4 in pipeline',
    status: 'Client review',
    tone: 'review',
    Icon: Clapperboard,
  },
  {
    id: 'harbor',
    name: 'Harbor Co',
    summary: '2 ready to publish',
    status: 'Approved',
    tone: 'approved',
    Icon: CheckCircle2,
  },
];

export default function AgencyControlDemo() {
  return (
    <div className="mkt-agency-board" aria-hidden>
      <div className="mkt-agency-board-header">
        <Building2 className="ui-icon-lg" aria-hidden />
        <div className="mkt-agency-board-header-copy">
          <p className="mkt-agency-board-kicker">Your agency</p>
          <p className="mkt-agency-board-title">Clients at a glance</p>
        </div>
      </div>

      <ul className="mkt-agency-board-list">
        {WORKSPACES.map((workspace) => {
          const Icon = workspace.Icon;
          return (
            <li key={workspace.id} className="mkt-agency-board-row">
              <span className={`mkt-agency-board-icon mkt-agency-board-icon--${workspace.tone}`}>
                <Icon className="ui-icon-md" aria-hidden />
              </span>
              <div className="mkt-agency-board-row-copy">
                <p className="mkt-agency-board-name">{workspace.name}</p>
                <p className="mkt-agency-board-summary">{workspace.summary}</p>
              </div>
              <span className={`mkt-agency-board-status mkt-agency-board-status--${workspace.tone}`}>
                {workspace.status}
              </span>
            </li>
          );
        })}
      </ul>

      <p className="mkt-agency-board-footer">A separate space for each client</p>
    </div>
  );
}
